import { render, staticRenderFns } from "./option_value.vue?vue&type=template&id=68b345b2&"
import script from "./option_value.vue?vue&type=script&lang=js&"
export * from "./option_value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports